/**
 * Shared visual tokens for icons across the app.
 *
 * Centralised so all icon-bearing surfaces (sidebar nav, animated tabs,
 * toolbars, etc.) render at the same stroke width. Lucide's default
 * `strokeWidth` is 2, which reads a bit heavy against our typography
 * scale; we run a slightly lighter weight for a more refined feel.
 *
 * Sizes intentionally live with the call site — different surfaces want
 * different sizes (14px in dense table headers, 16px in sidebar nav,
 * 18px in primary CTAs). The *stroke* on the other hand should be
 * uniform: that's what makes a family of icons feel like one family.
 *
 * Change in one place → propagates everywhere that imports it.
 */
export const ICON_STROKE = 1.6;
